import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import LinkIcon from "@mui/icons-material/Link";
import ImageIcon from "@mui/icons-material/Image";

const labelStyle = {
  fontFamily: "Nunito", fontSize: 11, fontWeight: 800, color: "#6b7280",
  textTransform: "uppercase", letterSpacing: 0.7, marginBottom: 6, display: "block",
};
const inputStyle = {
  width: "100%", boxSizing: "border-box", fontFamily: "Nunito", fontSize: 14,
  color: "#111827", border: "1px solid #e5e7eb", borderRadius: 8,
  padding: "10px 14px", outline: "none", background: "#fff",
};

const Index = () => {
  const [description, setdescription] = useState("");
  const [link, setlink] = useState("");
  const [image, setimage] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (description.length === 0) return toast.error("Enter description before sending");
    if (!image) return toast.error("Upload an image before submitting");
    if (!confirm("Are you sure you want to send this notification?")) return;
    await fetch("/api/admin/notification", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ image, adminBroadcast: description, linkey: link }),
    });
    setdescription("");
    setlink("");
    setimage(null);
    toast.success("Notification sent successfully!");
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (file.type !== "image/jpeg" && file.type !== "image/png")
      return toast.error("Only JPEG/PNG files are supported");
    if (file.size > 1024 * 1024) return toast.error("File size must be under 1 MB");
    const formdata = new FormData();
    formdata.append("image", file);
    setUploading(true);
    fetch("/api/admin/notification/uploadimage", { method: "POST", body: formdata })
      .then((r) => r.json())
      .then((data) => { setimage(data.location); toast.success("Image uploaded"); })
      .finally(() => setUploading(false));
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 24px", boxSizing: "border-box" }}>
      <div style={{ width: "100%", maxWidth: 600 }}>
      <ToastContainer />

      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 28 }}>
        <div style={{ background: "#111827", borderRadius: 10, width: 40, height: 40, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <NotificationsActiveIcon style={{ color: "#fff", fontSize: 20 }} />
        </div>
        <div>
          <h1 style={{ fontFamily: "Nunito", fontWeight: 800, fontSize: 26, color: "#111827", margin: 0 }}>
            Send Notification
          </h1>
          <p style={{ fontFamily: "Nunito", fontSize: 13, color: "#6b7280", margin: 0 }}>
            Broadcast a notification to all platform users
          </p>
        </div>
      </div>

      {/* Form card */}
      <div style={{ background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16, padding: "28px 32px" }}>
        <form onSubmit={handleSubmit}>

          {/* Description */}
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>Notification Message</label>
            <textarea
              rows={4}
              placeholder="Write the notification message…"
              value={description}
              onChange={(e) => setdescription(e.target.value)}
              style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }}
            />
          </div>

          {/* Link */}
          <div style={{ marginBottom: 20 }}>
            <label style={labelStyle}>
              <LinkIcon style={{ fontSize: 12, verticalAlign: "middle", marginRight: 4 }} />
              Redirect Link (optional)
            </label>
            <input
              type="text"
              placeholder="https://example.com/page"
              value={link}
              onChange={(e) => setlink(e.target.value)}
              style={inputStyle}
            />
          </div>

          {/* Image */}
          <div style={{ marginBottom: 28 }}>
            <label style={labelStyle}>
              <ImageIcon style={{ fontSize: 12, verticalAlign: "middle", marginRight: 4 }} />
              Notification Image
            </label>
            {image ? (
              <div style={{ display: "flex", alignItems: "center", gap: 16, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 10, padding: "12px 16px" }}>
                <img src={image} alt="preview" style={{ height: 64, width: 64, objectFit: "cover", borderRadius: 8, border: "1px solid #e5e7eb" }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <p style={{ fontFamily: "Nunito", fontSize: 13, fontWeight: 700, color: "#111827", margin: "0 0 4px" }}>Image uploaded</p>
                  <p style={{ fontFamily: "Nunito", fontSize: 12, color: "#6b7280", margin: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{image}</p>
                </div>
                <button
                  type="button"
                  onClick={() => setimage(null)}
                  style={{ fontFamily: "Nunito", fontSize: 12, fontWeight: 700, background: "#fff", color: "#dc2626", border: "1px solid #dc2626", borderRadius: 6, padding: "6px 12px", cursor: "pointer", flexShrink: 0 }}
                >
                  Remove
                </button>
              </div>
            ) : (
              <label style={{ display: "block", border: "2px dashed #e5e7eb", borderRadius: 10, padding: "28px", textAlign: "center", cursor: uploading ? "wait" : "pointer", background: "#f9fafb" }}>
                <ImageIcon style={{ fontSize: 32, color: "#9ca3af", display: "block", margin: "0 auto 8px" }} />
                <p style={{ fontFamily: "Nunito", fontSize: 13, fontWeight: 700, color: "#374151", margin: "0 0 4px" }}>
                  {uploading ? "Uploading…" : "Click to upload image"}
                </p>
                <p style={{ fontFamily: "Nunito", fontSize: 12, color: "#9ca3af", margin: 0 }}>JPEG or PNG · Max 1 MB</p>
                <input type="file" accept="image/png, image/jpeg" onChange={handleUpload} style={{ display: "none" }} />
              </label>
            )}
          </div>

          {/* Submit */}
          <button
            type="submit"
            style={{ width: "100%", fontFamily: "Nunito", fontSize: 14, fontWeight: 700, background: "#111827", color: "#fff", border: "none", borderRadius: 8, padding: "12px", cursor: "pointer" }}
          >
            Send Notification
          </button>
        </form>
      </div>
      </div>
    </div>
  );
};

export default Index;
